module.exports = __webpack_public_path__ + "static/img/sport.625cb4ab.png";